var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInpaint = function SvgInpaint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M6.98 16.98c-.644 0-1.23.586-1.23 1.29 0 .878-.234 1.757-.645 2.402.235.058.41.058.645.058 1.348 0 2.52-1.113 2.52-2.46a1.3 1.3 0 0 0-1.29-1.29M21.57.75q.528 0 .88.352L24.147 2.8c.47.469.47 1.289 0 1.758L12.957 15.75 9.5 12.293 20.691 1.102c.235-.235.586-.352.88-.352M6.98 14.52c2.11 0 3.75 1.64 3.75 3.75a4.976 4.976 0 0 1-4.98 4.98c-1.875 0-3.867-.996-4.98-2.52 1.054 0 2.46-.82 2.46-2.46 0-2.11 1.7-3.75 3.75-3.75"
  })));
};
export default SvgInpaint;